import { Subscription } from 'grids/subscription/subscription';

export const SubscriptionWrapper = (props) => {
  return <Subscription {...props} theme="dark" />;
};
